import Handlebars from 'handlebars';

export default class Map {
  constructor() {
    window.markers = [];
    window.popups = [];
    this.accessToken = 'pk.eyJ1Ijoia3RyYW5zaWVyIiwiYSI6IklHY2NDYWcifQ.0xeE0U0dU29hpiHM7Ea83w';
    this.style = 'mapbox://styles/ktransier/cjrboqgqt1z3y2slwirte7bn3';
  }

	build(response) {
    this.loadMarkers(response.records)
    this.loadCommunityRadius(response)
	}

	setupMap() {
		mapboxgl.accessToken = this.accessToken;
	  window.map = new mapboxgl.Map({
	    container: 'map',
      style: this.style
	  });
    window.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    return new Promise((resolve) => {
      window.map.on('load', resolve);
    });
	}

  incident_popup_html(data) {
    if (!$('#incident-card-template').length) {return};
    var source = $('#incident-card-template').html();
    var template = Handlebars.compile(source);
    return template(data);
  }

  combatant_location_popup_html(data) {
    if (!$('#combatant-location-card-template').length) {return};
    var source = $('#combatant-location-card-template').html();
    var template = Handlebars.compile(source);
    return template(data); 
  }

  returnee_popup_html(data) {
    if (!$('#returnee-card-template').length) {return};
    var source = $('#returnee-card-template').html();
    var template = Handlebars.compile(source);
    return template(data);
  }

  community_popup_html(data) {
    if (!$('#community-card-template').length) {return};
    var source = $('#community-card-template').html();
    var template = Handlebars.compile(source);
    return template(data);
  }

  popup_html(data) {
    let currentRecordType = document.getElementById('js-record-type').dataset.recordType;
    switch (currentRecordType) {
      case 'incidents':
        return this.incident_popup_html(data)
      case 'combatant_locations':
        return this.combatant_location_popup_html(data)
      case 'returnees':
        return this.returnee_popup_html(data)
      case 'communities':
        return this.community_popup_html(data)
      default:
        break;
    }
  }

  formatDate(date) {
   let month_names =
    [
    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];
    var date = new Date(date)
    var month = month_names[date.getMonth()]
    var day = date.getDate()
    var year = date.getFullYear()
    return month + " " + day + ", " + year
  };

  loadCommunityRadius(response) {
    if (window.map.getLayer('polygon')) window.map.removeLayer('polygon');
    if (window.map.getSource('polygon')) window.map.removeSource('polygon');
    if ( $('.js-filter-community-id-option').val() && 
      $('#js-filter-radius-option').val() ) {
      window.map.addSource("polygon", 
        createGeoJSONCircle([response.community_longitude, response.community_latitude], 
          $('#js-filter-radius-option').val())
      );

      window.map.addLayer({
          "id": "polygon",
          "type": "fill",
          "source": "polygon",
          "layout": {},
          "paint": {
              "fill-color": "#fb963b",
              "fill-opacity": 0.2,
          }
      });
    };
  }

	loadMarkers(markerDataset) {
    this.clearMarkers();
    var bounds = new mapboxgl.LngLatBounds();

    markerDataset.forEach((markerData) => {
	    var element = document.createElement('div');

      var displayType = document.getElementById('js-display-type').dataset.displayType
      var indicator = displayType == 'incident_type' ? markerData["primary_indicator_type"] : markerData["indicator_actor_type"]
      element.className = 'record-indicator record-indicator-' + indicator;

	    if (Math.abs(markerData["latitude"]) > 0 && Math.abs(markerData["latitude"]) <= 90 && 
          Math.abs(markerData["longitude"]) > 0 && Math.abs(markerData["longitude"]) <= 90) {
        
        var popup = new mapboxgl.Popup({ offset: 25, className: markerData["id"]})
          .setHTML(this.popup_html(markerData));
        // Roughly offset by 100 meters
        let latitudeOffset = (Math.random() * (0.009 - 0.001) + 0.001)
        let longitudeOffset = (Math.random() * (0.009 - 0.001) + 0.001)
  	    let coordinates = [markerData["longitude"] + longitudeOffset, markerData["latitude"] + latitudeOffset];
  			let marker = new mapboxgl.Marker(element)
  	      .setLngLat(coordinates)
        if (this.popup_html(markerData)) { 
          marker.setPopup(popup)
        }
        marker.addTo(window.map);
        window.markers.push(marker);
        window.popups.push(popup)        
  	    bounds.extend(coordinates);
      }
    })
    if (markerDataset.length === 1) {
      window.map.jumpTo({
        center: [markerDataset[0]["longitude"], markerDataset[0]["latitude"]],
        zoom: 6,
      });
    } else if (markerDataset.length > 1) {
      if (window.screen.availWidth > 768) {
        window.map.fitBounds(bounds, {duration: 0, padding: {top: 120, bottom: 40, left: 450, right: 40}});  
      } else {
        window.map.fitBounds(bounds, {duration: 0});  
      }
    }
	}

  static openPopup(recordId) {
    popups.map((popup) => { popup.remove() })
    let popup = popups.find((popup) => { return popup.options.className === recordId});
    popup.addTo(window.map);
  }

  clearMarkers() {
    window.markers.forEach((marker) => {
      marker.remove();
    })

    window.markers = [];
  }
}


var createGeoJSONCircle = function(center, radiusInKm, points) {
    if(!points) points = 64;

    var coords = {
        latitude: center[1],
        longitude: center[0]
    };

    var km = radiusInKm;

    var ret = [];
    var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
    var distanceY = km/110.574;

    var theta, x, y;
    for(var i=0; i<points; i++) {
        theta = (i/points)*(2*Math.PI);
        x = distanceX*Math.cos(theta);
        y = distanceY*Math.sin(theta);

        ret.push([coords.longitude+x, coords.latitude+y]);
    }
    ret.push(ret[0]);

    return {
        "type": "geojson",
        "data": {
            "type": "FeatureCollection",
            "features": [{
                "type": "Feature",
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [ret]
                }
            }]
        }
    };
};
